import React, { useState, useContext, useCallback, useEffect } from "react";
import { NotificationManager } from "react-notifications";
import Switch from "react-switch";
import { useParams } from "react-router-dom";
import useApi from "../Api/Api";
import SalesLayout from "./SalesLayout";
import EventLayout from "./EventLayout";
import { FilterContext } from "../FilterContextProvider";
import Button from "../Components/Button";
import useAllProducts from "../hooks/useAllProducts";
import storageManager from "../Utility/StorageManager";
import OnlineWrapper from "./OnlineWrapper";
import OfflineWrapper from "./OfflineWrapper";

const TonightsProducts = () => {
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const { filterData } = useContext(FilterContext);
  const api = useApi();
  const params = useParams();
  const [showButtons, setShowButtons] = useState(false);
  const [productsToRender, setProductsToRender] = useState([]);
  const [allSales, setAllSales] = useState([]);
  const [dataCached, setDataCached] = useState(false);
  const [cachedSales, setCachedSales] = useState([]);
  const { allProducts, fetchProducts } = useAllProducts("");
  const [allActive, setAllActive] = useState(false);

  const [event, setEvent] = useState({
    date: "",
    id: params.eventId,
  });

  useEffect(() => {
    storageManager.getItem(`event/${event.id}/sales`) &&
      setCachedSales(Object.values(JSON.parse(storageManager.getItem(`event/${event.id}/sales`))));
  }, [event.id]);

  for (let i = 0; i < cachedSales.length; i++) {
    for (let j = 0; j < allSales.length; j++) {
      if (cachedSales[i]?.product_id === allSales[j]?.product_id) {
        allSales[j] = cachedSales[i];
      }
    }
  }

  allSales.forEach((sale) => {
    if (
      sale.count_in > 0 ||
      sale.add > 0 ||
      sale.add_2 > 0 ||
      sale.add_3 > 0 ||
      sale.add_4 > 0 ||
      sale.count_out > 0 ||
      sale.discount_quantity > 0 ||
      sale.band_comp_quantity > 0 ||
      sale.management_comp > 0 ||
      sale.ctm_comp > 0 ||
      sale.damage_quantity > 0
    ) {
      sale.disable_toggle = true;
      const match = productsToRender.find((one) => one.id === sale.product_id);
      productsToRender.forEach((one) => {
        if (one.name === match.name) {
          one.disabled = true;
        }
      });
    }
    sale.quantity =
      parseInt(sale.count_in) +
      parseInt(sale.add) +
      parseInt(sale.add_2) +
      parseInt(sale.add_3) +
      parseInt(sale.add_4) -
      parseInt(sale.count_out) -
      parseInt(sale.damage_quantity) -
      parseInt(sale.discount_quantity) -
      parseInt(sale.band_comp_quantity) -
      parseInt(sale.ctm_comp) -
      parseInt(sale.management_comp);
    sale.gross = sale.quantity * sale.price;
  });

  const productsToUse = allProducts.filter(
    (prod) => prod.active === true || allSales.find((sale) => sale.product_id === prod.id)
  );

  const productCategories = [
    ...new Set(productsToUse.map((product) => `${product.category?.index} - ${product.category?.name}`)),
  ];

  productCategories.sort((a, b) => a.localeCompare(b));

  const productNames = [
    ...new Set(productsToUse.map((product) => `${product.name}*${product.category?.name}*%${product.image_url}`)),
  ];

  productNames.sort((a, b) => a.localeCompare(b));

  const productPrices = [
    ...new Set(productsToUse.map((product) => `${product.name}*${product.category?.name}*${product.retail_price}`)),
  ];

  const allSalesProductNames = [
    ...new Set(
      allSales.map(
        (sale) =>
          `${sale.product_name}*${sale.product_category}*%${sale.disable_toggle}%${sale.quantity}%${sale.gross}%${sale.product_size}`
      )
    ),
  ];

  for (let i = 0; i < productNames.length; i++) {
    for (let j = 0; j < allSalesProductNames.length; j++) {
      if (productNames[i].split("%")[0] === allSalesProductNames[j].split("%")[0]) {
        if (allSalesProductNames[j].split("%")[1] === "true") {
          productNames[i] = productNames[i].concat("%disabled");
        }
        productNames[i] = productNames[i].concat("%true");
      }
    }
    for (let k = 0; k < cachedSales.length; k++) {
      if (productNames[i].split("%")[0].split("*")[0] === cachedSales[k].name) {
        if (cachedSales[k].discarded_at) {
          productNames[i] = productNames[i].concat(`%false`);
        } else if (!cachedSales[k].discarded_at) {
          productNames[i] = productNames[i].concat(`%true`);
        }
      }
    }
  }

  const handleToggle = (name, state, offlineState) => {
    setDataCached(offlineState);
    setShowButtons(true);
    const productsToCache = [...productsToRender];
    productsToCache.forEach((each) => {
      if (each.name === name.split("*")[0]) {
        each.product_id = each.id;
        each.product_name = each.name;
        each.event_id = event.id;
        each.product_category = each.category?.name;
        each.category_id = each.category?.id;
        each.size_id = each.size?.id;
        each.price = each.retail_price;
        if (each.size_other) {
          each.product_size = each.size_other;
        } else if (each.size?.name) {
          each.product_size = each.size.name;
        } else if (!each.size) {
          each.product_size = null;
        }
        for (let j = 0; j < allSales.length; j++) {
          if (allSales[j].product_id === each.id) {
            each.sale_id = allSales[j].id;
          } else {
            each.discount_price = 0;
            each.count_in = 0;
            each.add = 0;
            each.add_2 = 0;
            each.add_3 = 0;
            each.add_4 = 0;
            each.count_out = 0;
            each.discount_quantity = 0;
            each.band_comp_quantity = 0;
            each.ctm_comp = 0;
            each.management_comp = 0;
            each.damage_quantity = 0;
            each.total = 0;
            each.discount_total = 0;
          }
        }
        let currentEventState = JSON.parse(storageManager.getItem(`event/${event.id}/sales`) ?? "{}");
        if (state) {
          if (each.sale_id) {
            delete currentEventState[each.product_id];
          } else {
            currentEventState[each.product_id] = each;
            currentEventState[each.product_id].date = event.date;
            currentEventState[each.product_id].new = true;
          }
        } else {
          if (each.sale_id) {
            currentEventState[each.product_id] = each;
            currentEventState[each.product_id].discarded_at = new Date().toISOString();
          } else {
            delete currentEventState[each.product_id];
          }
        }
        storageManager.setItem(`event/${event.id}/sales`, JSON.stringify(currentEventState));
      }
      return each;
    });
    setCachedSales(Object.values(JSON.parse(storageManager.getItem(`event/${event.id}/sales`))));
  };

  const revert = () => {
    let message = "Are you sure you want to revert? All unsaved changes will be lost.";
    const check = window.confirm(message);
    if (check) {
      cachedSales.forEach((each) => {
        let currentEventState = JSON.parse(storageManager.getItem(`event/${event.id}/sales`) ?? "{}");
        delete currentEventState[each.id];
        storageManager.setItem(`event/${event.id}/sales`, JSON.stringify(currentEventState));
      });
      setCachedSales([]);
      setShowButtons(false);
    }
  };

  const afterSubmit = () => {
    getAllSales();
    fetchProducts();
  };

  const handleSubmit = (e) => {
    setIsFetching(true);
    cachedSales.forEach((one) => {
      one.sale_id ? (one.id = one.sale_id) : delete one.id;
    });
    cachedSales.length > 0 &&
      api
        .put(`/events/${event.id}`, {
          event: {
            sales_attributes: cachedSales.map((each) => each),
          },
        })
        .then((response) => {
          for (let key of storageManager.keys()) {
            if (key.startsWith(`event/${event.id}/sales`)) {
              storageManager.removeItem(key);
            }
          }
          NotificationManager.success("Tonight's products updated ", "Success", 2000);
          setCachedSales([]);
          afterSubmit();
          setErrorMessage(false);
          return response;
        })
        .catch((error) => {
          setIsFetching(false);
          setErrorMessage(error?.response?.data || error);
        })
        .finally(() => {});
    e.preventDefault();
    setIsFetching(false);
    setShowButtons(false);
    afterSubmit();
  };

  const handleOfflineSubmit = () => {
    setShowButtons(false);
    NotificationManager.warning(
      "You are currently operating offline. Your changes have been cached for now, and you will be able to sync once you are online again.",
      "Warning",
      10000
    );
  };

  const getEvent = useCallback(() => {
    api.get(`/events/${params.eventId}`).then((r) => {
      setEvent(r.data);
    });
  }, [api, setEvent, params.eventId]);

  const getAllSales = useCallback(() => {
    api.get(`/sales/all?artist_id=${filterData.artist_id}&event_id=${params.eventId}`).then((r) => {
      setAllSales(r.data);
    });
  }, [filterData, api, params.eventId]);

  useEffect(() => {
    getEvent();
    getAllSales();
  }, [getEvent, getAllSales]);

  useEffect(() => {
    setProductsToRender([
      ...allProducts.filter((prod) => prod.active === true || allSales.find((sale) => sale.product_id === prod.id)),
    ]);
  }, [allProducts, allSales]);

  const activateAll = (offlineState) => {
    setDataCached(offlineState);
    setAllActive(!allActive);
    setShowButtons(true);
    const productsToCache = [...productsToRender];
    productsToCache
      .filter((each) => !each.disabled)
      .forEach((each) => {
        if (each.name === each.name.split("*")[0]) {
          each.product_id = each.id;
          each.product_name = each.name;
          each.event_id = event.id;
          each.product_category = each.category?.name;
          each.category_id = each.category?.id;
          each.size_id = each.size?.id;
          each.price = each.retail_price;
          if (each.size_other) {
            each.product_size = each.size_other;
          } else if (each.size?.name) {
            each.product_size = each.size.name;
          } else if (!each.size) {
            each.product_size = null;
          }
          for (let j = 0; j < allSales.length; j++) {
            if (allSales[j].product_id === each.id) {
              each.sale_id = allSales[j].id;
            } else {
              each.discount_price = 0;
              each.count_in = 0;
              each.add = 0;
              each.add_2 = 0;
              each.add_3 = 0;
              each.add_4 = 0;
              each.count_out = 0;
              each.discount_quantity = 0;
              each.band_comp_quantity = 0;
              each.ctm_comp = 0;
              each.management_comp = 0;
              each.damage_quantity = 0;
              each.total = 0;
              each.discount_total = 0;
            }
          }
          let currentEventState = JSON.parse(storageManager.getItem(`event/${event.id}/sales`) ?? "{}");
          if (!allActive) {
            if (each.sale_id) {
              delete currentEventState[each.product_id];
            } else {
              currentEventState[each.product_id] = each;
              currentEventState[each.product_id].date = event.date;
              currentEventState[each.product_id].new = true;
            }
          } else {
            if (each.sale_id) {
              currentEventState[each.product_id] = each;
              currentEventState[each.product_id].discarded_at = new Date().toISOString();
            } else {
              delete currentEventState[each.product_id];
            }
          }
          storageManager.setItem(`event/${event.id}/sales`, JSON.stringify(currentEventState));
        }
        return each;
      });
    setCachedSales(Object.values(JSON.parse(storageManager.getItem(`event/${event.id}/sales`))));
  };

  const renderSwitch = (productName, onlineState) => {
    return (
      <Switch
        onChange={(state) => {
          handleToggle(productName, state, onlineState);
        }}
        checked={productName.slice(productName.length - 4) === "true"}
        height={22}
        width={40}
        onColor="#3b82f6"
        offColor="#d4d4d8"
        disabled={productName.includes("disabled")}
        className="switch"
      />
    );
  };

  return (
    <SalesLayout>
      <EventLayout dataCached={dataCached} setDataCached={setDataCached} afterSubmit={afterSubmit}>
        <div className="flex justify-end -mb-6 self-center">
          {allActive ? (
            <label htmlFor="activate_all" className="mr-2">
              Uncheck all
            </label>
          ) : (
            <label htmlFor="activate_all" className="mr-2">
              Check all
            </label>
          )}
          <OnlineWrapper>
            <Switch
              onChange={() => {
                activateAll(false);
              }}
              checked={allActive}
              height={22}
              width={40}
              onColor="#3b82f6"
              offColor="#d4d4d8"
              id="activate_all"
            />
          </OnlineWrapper>
          <OfflineWrapper>
            <Switch
              onChange={() => {
                activateAll(true);
              }}
              checked={allActive}
              height={22}
              width={40}
              onColor="#3b82f6"
              offColor="#d4d4d8"
              id="activate_all"
            />
          </OfflineWrapper>
        </div>
        {(showButtons || !allSales.length) && (
          <div>
            <div className="flex justify-center">
              <Button
                className="button button-white mr-2"
                onClick={revert}
                text="Revert"
                disabled={isFetching}
              ></Button>
              <OnlineWrapper>
                {!dataCached && (
                  <Button
                    className="button"
                    onClick={handleSubmit}
                    text={isFetching ? `Loading ${"\u00A0"}` : "Update"}
                    disabled={isFetching}
                    inProgress={isFetching}
                  ></Button>
                )}
              </OnlineWrapper>
              <OfflineWrapper>
                <Button
                  className="button"
                  onClick={handleOfflineSubmit}
                  text={isFetching ? `Loading ${"\u00A0"}` : "Update"}
                  disabled={isFetching}
                  inProgress={isFetching}
                ></Button>
              </OfflineWrapper>
            </div>
          </div>
        )}
        <form>
          {productCategories.map((category, i) => (
            <div className="font-semibold" key={i}>
              <div className="text-black mt-4 mb-2 text-lg">{category.split("-")[1]}</div>
              <hr></hr>
              <div className="flex flex-wrap text-sm mt-6">
                {productNames.map((productName, j) => {
                  let gross = 0;
                  let quantity = 0;
                  return (
                    <div key={j}>
                      {productName.split("*")[1] === category.split("-")[1].trim() && (
                        <div className="pt-2 pl-2 border border-gray-300 m-2 min-w-64 min-h-20 rounded-lg">
                          {productName.split("%")[1] && (
                            <div className="flex items-center">
                              <img src={productName.split("%")[1]} alt="Product" className="h-16 rounded-md" />
                            </div>
                          )}
                          <div
                            className={productName.split("%")[1] ? "grid text-black ml-20 -mt-16" : "grid text-black"}
                            id={`product_name_${j}`}
                          >
                            {productName.split("*")[0]}
                            {allSalesProductNames.map((sale) => {
                              if (productName.split("*")[0] === sale.split("*")[0]) {
                                if (sale.split("%")[2] > 0 || sale.split("%")[2] < 0) {
                                  quantity += parseInt(sale.split("%")[2]);
                                }
                                if (sale.split("%")[3] > 0 || sale.split("%")[3] < 0) {
                                  gross += parseInt(sale.split("%")[3]);
                                }
                              }
                              return null;
                            })}
                            <div className="my-1 font-normal">Quantity: {quantity}</div>
                            <div className="mb-1 font-normal">Gross: ${gross}</div>
                          </div>
                          {productPrices.map((productPrice, k) => (
                            <div key={k} className={productName.split("%")[1] && "ml-12"}>
                              {productPrice.split("*")[0] === productName.split("*")[0] && (
                                <div
                                  className={
                                    productName.split("%")[1]
                                      ? "flex text-black font-light -ml-12"
                                      : "flex text-black font-light"
                                  }
                                  id={`product_price_${k}`}
                                >
                                  ${productPrice.split("*")[2]}
                                  {productsToRender
                                    .sort((a, b) => (a.size?.index < b.size?.index ? -1 : 1))
                                    .map((product, l) => (
                                      <div key={l}>
                                        {productName.split("*")[0] === product.name &&
                                          product.retail_price === parseInt(productPrice.split("*")[2]) && (
                                            <>
                                              {product.size && <div>&nbsp;{product.size?.name}</div>}
                                              {product.size_other && <div>&nbsp;{product?.size_other}</div>}
                                            </>
                                          )}
                                      </div>
                                    ))}
                                </div>
                              )}
                            </div>
                          ))}
                          <div className="flex justify-end mr-2 -mt-6 mb-2">
                            <OnlineWrapper>{renderSwitch(productName, false)}</OnlineWrapper>
                            <OfflineWrapper>{renderSwitch(productName, true)}</OfflineWrapper>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </form>
        <div className="flex justify-center mt-8">
          {errorMessage?.error && <div className="text-red-500 pb-2">{errorMessage.error}</div>}
        </div>
      </EventLayout>
    </SalesLayout>
  );
};

export default TonightsProducts;
